import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class BulkCreateService {

  constructor(private apiService: ApiService, private authService: AuthService) { }

  public downloadBulkBookingTemplate(type: string): Observable<any[]> {
    const pathParams = {
      client: this.authService.client.client,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid
    };
    return this.apiService.httpRequestBlob({
      url: type === 'single' ? 'fetchBulkUploadTemplate' : 'fetchMultiStopBulkUploadTemplate',
      type: 'GET',
      queryParams: pathParams,
    });
  }

  public uploadBulkBooking(request: any): Observable<any> {
    const postData = new FormData();
    postData.append('uploadfile', request.uploadFile);
    const queryParams = {
      client: this.authService.client.client,
      buid: this.authService.user.buId,
      empGuid: this.authService.user.employeeGuid
    };
    return this.apiService.httpRequestFileUploadProgress({
      url: 'uploadBulkBooking',
      type: 'POST',
      body: postData,
      queryParams,
      fileUpload: true
    });
  }
}
